import http from "@/http/aisea/axios";
const resource = "/secure_dataflow/enterprise/vessels";

export default {
  getSeaRoutes(vesselId, params) {
    return http.get(`${resource}/${vesselId}/sea_routes`, {
      params: params
    });
  },
  getSeaRouteDetail(vesselId, voyageHistoryId, params) {
    return http.get(`${resource}/${vesselId}/voyage_history/${voyageHistoryId}/sea_routes`, {
      params: params
    });
  }
};
